import { useMatch } from 'react-router-dom';
import { RoutePaths } from 'types/enums';

export const useDownloadsPageMatch = (): { isDownloadsPage: boolean } => {
    const match = useMatch(`/${RoutePaths.Downloads}`);

    const isDownloadsPage =
        !!match && match.pathname === `/${RoutePaths.Downloads}`;

    return { isDownloadsPage };
};
